import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Template } from '../../../../models/template';
import { AlertService } from '../../../../services/alert.service';
import { AutoUnsubscribe } from '../../../../decorators/auto-unsubscribe';
import { Subscription } from 'rxjs';
import { NgxPopupComponent } from '../../../shared/ngx-popups/ngx-popups/components/popup.component';
import { Operation } from '../../../../models/operation';
import { DataFrameService } from '../../../../services/dataframes.service';
import { DataFrameGenerator } from '../../../../models/dataframe-generator';
import { FormulaService } from '../../../../services/formula.service';

@Component({
    selector: 'app-templates',
    templateUrl: './load-templates.component.html',
    styleUrls: ['./load-templates.component.scss'],
    standalone: false
})
@AutoUnsubscribe('subsArr$')
export class LoadTemplatesComponent {
  @Input() popup: NgxPopupComponent;
  @Input() generator: DataFrameGenerator;
  @Input() companyId: number;
  @Input() templates;
  subsArr$: Subscription[] = [];
  disableSaveButton = true;
  operations: Operation[];
  lockedOperations: Operation[];
  selectedTemplateId: number;
  selectedTemplate: Template;

  constructor(private _dataFrameService: DataFrameService,
              private _alertService: AlertService,
              private _formulaService: FormulaService,
) {
    this.operations = [];
    this.lockedOperations = [];
  }

  loadTemplateIntoSpreader() {
    if (!this.selectedTemplateId) {
      return;
    }
    this.disableSaveButton = true;
    this.subsArr$.push(this._dataFrameService.applyTemplateToGenerator(this.generator, this.selectedTemplate, true).subscribe(dfg => {
      this.generator = dfg;
      this._alertService.success('Template applied! (Note that duplicate items are not imported from templates.');
      this.popup.close(true, true);

      // Since we've applied a template, we need to get all available formula variables again
      this._formulaService.getAllFormulaVariables(this.companyId);
    }, error => {
      this._alertService.error(error.message);
      this.disableSaveButton = false;
    }))
  }

  changeTemplate(value) {
    const templateId = value.toString()
    const isATemplateSelected = !!templateId.length;

    this.disableSaveButton = !isATemplateSelected;
    if (!isATemplateSelected) {
      this.operations = [];
      this.lockedOperations = [];
      this.selectedTemplateId = 0;
      return;
    }

    const index = parseInt(templateId, 10);
    this.selectedTemplate = this.templates[index];
    this.selectedTemplateId = this.selectedTemplate.id;
    this.operations = this.selectedTemplate.operations;
    if ('lockedOperations' in this.selectedTemplate) {
      this.lockedOperations = this.selectedTemplate.lockedOperations;
    }
  }
}
